import { IExamSession, ISessionItems } from '../../models/session.types';

export interface DialogBreadcrumbsProps {
  id: string;
  level: BreadcrumbLevel;
  session: IExamSession;
  changeHandler: (level: BreadcrumbLevel, id: string) => void;
  sessionItems: ISessionItems;
}

export enum BreadcrumbLevel {
  SESSION = 'session',
  EXAM = 'exam',
  EXAMSHEET = 'examSheet',
  TASKGROUP = 'taskGroup',
  TASK = 'task',
  GRADERULES = 'gradeRules',
  SCHEMA = 'schemeScores',
  CRITERIA_SETUP = 'criteriaSetup',
}

export interface Breadcrumb {
  id: string;
  level: BreadcrumbLevel;
  name: string;
}
